export default {
      id: "phone-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.1790760972825.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }